export default {"src":"/_next/static/media/sauna.24e6b842.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};